import PropTypes from 'prop-types';
import { Checkbox, Input } from '../../../common/components';
import RemoveButton from './RemoveButton';

const AccountRow = ({ accountSetIndex, accountIndex, account, setFieldValue, removeAccount }) => {
  const ARRAYNAME = `accountSets.${accountSetIndex}`;
  return (
    <tr>
      <td>{accountIndex === 0 ? accountSetIndex + 1 : ''}</td>
      <td>{account.accountNumber}</td>
      <td>{account.description}</td>
      <td className="checkbox-table">
        <Checkbox
          onChange={() => {
            if (account.debit) {
              setFieldValue(`${ARRAYNAME}.${accountIndex}.debit`, false);
              setFieldValue(`${ARRAYNAME}.${accountIndex}.credit`, true);
            } else {
              setFieldValue(`${ARRAYNAME}.${accountIndex}.debit`, true);
              setFieldValue(`${ARRAYNAME}.${accountIndex}.credit`, false);
            }
          }}
          label=""
          name={`${ARRAYNAME}.${accountIndex}.debit`}
          checked={account.debit}
        />
      </td>
      <td className="checkbox-table">
        <Checkbox
          onChange={() => {
            if (account.credit) {
              setFieldValue(`${ARRAYNAME}.${accountIndex}.credit`, false);
              setFieldValue(`${ARRAYNAME}.${accountIndex}.debit`, true);
            } else {
              setFieldValue(`${ARRAYNAME}.${accountIndex}.credit`, true);
              setFieldValue(`${ARRAYNAME}.${accountIndex}.debit`, false);
            }
          }}
          label=""
          name={`${ARRAYNAME}.${accountIndex}.credit`}
          checked={account.credit}
        />
      </td>
      <td>
        <Input
          formInput
          name={`${ARRAYNAME}.${accountIndex}.allocationPercentage`}
          type="number"
          className="percentage-allocation-input"
          placeholder="00"
          max="100"
          min="0"
        />
      </td>
      <td>
        <RemoveButton onClick={removeAccount} />
      </td>
    </tr>
  );
};

AccountRow.propTypes = {
  accountSetIndex: PropTypes.number.isRequired,
  accountIndex: PropTypes.number.isRequired,
  account: PropTypes.shape({
    accountNumber: PropTypes.string,
    accountNumberData: PropTypes.shape({
      accountNumber: PropTypes.string,
      accountNumberId: PropTypes.number,
      description: PropTypes.string,
    }),
    allocationPercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    credit: PropTypes.bool,
    debit: PropTypes.bool,
    description: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  removeAccount: PropTypes.func.isRequired,
};

export default AccountRow;
